import { ReactComponent as BellSvg } from "assets/svgs/alerts-bell.svg";
import { ReactComponent as IllustrationSvg } from "assets/svgs/alerts-hero-illustration.svg";
import {
  HeroWrapper,
  HeroInner,
  HeroTop,
  HeroArt,
  HeroText,
  HeroTitle,
  HeroSubtitle,
  HeroSlot,
  BellIcon,
} from "./styles";
import type { AlertsHeroProps } from "./types";

/**
 * Hero da área de alertas.
 *
 * Exibe o fundo em gradiente âmbar, a ilustração (somente em telas largas),
 * o ícone de sino, o título e o subtítulo, todos exportados do design (XD).
 * O conteúdo recebido em `children` (ex.: a barra do formulário) é
 * renderizado abaixo dos textos.
 *
 * @param title - Título alternativo (ex.: "Editar alerta").
 * @param children - Conteúdo exibido abaixo dos textos.
 */
export const AlertsHero = ({ title, children }: AlertsHeroProps) => (
  <HeroWrapper>
    <HeroInner>
      <HeroTop>
        <HeroArt aria-hidden="true">
          <IllustrationSvg />
        </HeroArt>
        <HeroText>
          <BellIcon aria-hidden="true">
            <BellSvg />
          </BellIcon>
          <HeroTitle>
            {title || "Seja avisado quando sua passagem ideal chegar"}
          </HeroTitle>
          <HeroSubtitle>
            Crie alertas de preços e nós te avisamos quando encontrarmos a
            passagem aérea no valor que você escolheu!
          </HeroSubtitle>
        </HeroText>
      </HeroTop>
      {children && <HeroSlot>{children}</HeroSlot>}
    </HeroInner>
  </HeroWrapper>
);

export default AlertsHero;
